<template>
  <div class="player-container">
    <video v-if="videoData" controls autoplay class="video-player">
      <source :src="videoData.url" type="video/mp4" />
      您的浏览器不支持视频播放
    </video>
    <h2 v-if="videoData">{{ videoData.title }}</h2>
    <div v-else>视频加载中…………</div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const videos = ref([
      {
        id: 1,
        title: "基站指示灯效果-未联网",
        thumbnail:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319215241-基站指示灯效果-未联网.mp4",
        url:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319215241-基站指示灯效果-未联网.mp4",
      },
      {
        id: 2,
        title: "基站指示灯效果-已联网",
        thumbnail:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319223701-基站指示灯效果-已联网.mp4",
        url:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319223701-基站指示灯效果-已联网.mp4",
      },
      {
        id: 3,
        title: "基站指示灯效果-已联网",
        thumbnail:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319223745-基站指示灯效果-已联网.mp4",
        url:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319223745-基站指示灯效果-已联网.mp4",
      },
    ]);
    const videoData = ref(null);

    onMounted(() => {
      console.log(
        "VideoPlayer.onMounted(): params=",
        route.params,
        "videos=",
        videos.value
      );

      const videoId = route.params.id;
      videoData.value = videos.value.find((v) => v.id === parseInt(videoId));

      console.log("videoData.value=", videoData.value);
      if (!videoData.value) {
        console.log("未找到视频数据");
      }
    });

    return { videoData };
  },
};
</script>

<style scoped>
.player-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
.video-player {
  width: 100%;
  outline: none;
}
</style>
